import { __GLOBAL_TENANT } from "@/client/globals";

export function lecturerHeaders(contentType?: string): Headers {
  const headers = new Headers({
    "x-cadmus-role": "lecturer",
    "x-cadmus-tenant": __GLOBAL_TENANT.current ?? "",
  });

  if (contentType != null) {
    headers.set("Content-Type", contentType);
  }

  return headers;
}
